export default __webpack_public_path__ + "static/media/head_3_female.dd82e264.png";